export const SEND_DATE = 'SEND_DATE'
export const SEND_NOTIFICATION_FAIL = 'SEND_NOTIFICAION_FAIL'